<template>
  <v-row class="rounded gradient" id="employe-carusel">
    <v-col class="px-6">
      <v-carousel
        :height="$vuetify.breakpoint.xs ? 100 : 150"
        cycle
        :show-arrows="false"
        hide-delimiter-background
        delimiter-icon="mdi-circle-medium"
      >
        <v-carousel-item v-for="(slide, i) in content" :key="i">
          <v-sheet class="transparent">
            <v-row align="center">
              <div>
                <nuxt-link
                  :to="content[i].Link"
                  class="border-none headerLogo"
                  title="דרושים IL"
                >
                  <p class="display-26 pr-3 mb-0 white--text">
                    {{ content[i].Title }}
                    <span>
                      <v-icon>mdi-arrow-left-thick</v-icon>
                    </span>
                  </p>
                </nuxt-link>
              </div>
            </v-row>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
    </v-col>
  </v-row>
</template>   

<script>
export default {
  props: {
    content: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
}
</script>

<style lang="scss">
.mango {
  background-color: #ee9e42;
}
.carrot-light {
  background-color: #ed6c2e;
}
#employe-carusel .v-carousel__controls {
  justify-content: right !important;
}

.gradient {
  background: linear-gradient(to left, #ee9e42, #fe6206);
}

.transparent {
  background: none !important;
}

#employe-carusel
  > div.px-6.rounded.gradient.col-md-10.col
  > div
  > div.v-carousel__controls
  > div
  > button {
  margin: 0;
  align-self: flex-end;
}
</style>